import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router";
import { FormPage } from "./FormPage";
import { resolveQRCode } from "services/formBuilderService";

export default function QRFormPage() {
    const { token } = useParams();
    const navigate = useNavigate();
    const [formId, setFormId] = useState(null);
    const [assignTo, setAssignTo] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        resolve();
    }, []);

    const resolve = async () => {
        const result = await resolveQRCode(token);

        if (!result.data) {
            setError("Invalid or expired QR code");
            return;
        }

        // Extract FormId and CreatedBy from the response and reuse FormPage
        setFormId(result.data.FormId);
        setAssignTo(result.data.CreatedBy);
    };

    if (error) {
        return (
            <div className="flex h-screen items-center justify-center text-red-600">
                {error}
            </div>
        );
    }

    if (!formId) {
        return (
            <div className="flex h-screen items-center justify-center">
                Resolving QR code...
            </div>
        );
    }

    // 👇 reuse same component
    return <FormPage formId={formId}  qrToken={token} />;
}
